import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LogoWithText } from './LogoWithText';
import { useLanguage } from '../contexts/LanguageContext';
import { MessageIcon, PhoneIcon, BuildingIcon, TelegramIcon, InstagramIcon } from './Icons';

const Footer = () => {
  const { t, language } = useLanguage();
  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const contactInfo = [
    {
      icon: MessageIcon,
      value: 'info@adde.app',
      link: 'mailto:info@adde.app'
    },
    {
      icon: PhoneIcon,
      value: '+998 92 010 00 02',
      link: 'tel:+998920100002'
    },
    {
      icon: BuildingIcon,
      value: t('footerAddressValue'),
      link: null
    }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <LogoWithText />
            <p className="footer-description">
              {t('footerDescription')}
            </p>
            <div className="footer-contact-info">
              {contactInfo.map((info, index) => {
                const IconComponent = info.icon;
                return (
                  <a
                    key={index}
                    href={info.link || '#'}
                    className="footer-contact-item"
                    onClick={info.link ? null : (e) => e.preventDefault()}
                  >
                    <IconComponent size={16} className="footer-contact-icon" />
                    <span className="footer-contact-value">{info.value}</span>
                  </a>
                );
              })}
            </div>
            <div className="footer-social">
              <h4 className="footer-social-title">{t('footerFollowUs')}</h4>
              <div className="footer-social-links">
                <a
                  href="https://www.instagram.com/addeapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link footer-social-link--instagram"
                  aria-label="Instagram — @addeapp"
                >
                  <InstagramIcon size={22} className="footer-social-svg" />
                </a>
                <a
                  href="https://t.me/addeapp"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-social-link footer-social-link--telegram"
                  aria-label="Telegram — @addeapp"
                >
                  <TelegramIcon size={22} className="footer-social-svg" />
                </a>
              </div>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">{t('footerProduct')}</h4>
              <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); }}>{t('navFeatures')}</a>
              <a href="#solutions" onClick={(e) => { e.preventDefault(); scrollToSection('solutions'); }}>{t('navSolutions')}</a>
              <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); }}>{t('navPricing')}</a>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">{t('footerCompany')}</h4>
              <a href="#ai-analytics" onClick={(e) => { e.preventDefault(); scrollToSection('ai-analytics'); }}>{t('navAIAnalytics')}</a>
              <Link to="/contact">{t('navContact')}</Link>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">{t('footerLegal')}</h4>
              <Link to={`/privacy/${language}`}>{t('footerPrivacy')}</Link>
              <Link to={`/offer/${language}`}>{t('footerTerms')}</Link>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} Add-e. {t('footerRights')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
